import React, { useEffect, useState } from 'react'
import { Constants } from '../../../../CommonMethhods/Constants';
import { AESEncryption, ApiResDecrypt, noDataFound } from '../../../../CommonMethhods/CommonMethods';
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from '../../../../Configuration/API_URL';
import axios from 'axios';
import { toast } from 'react-toastify';
import SmallLoader from '../../../Common/smallLoader';
import Loader from '../../../Common/Loader';

export default function NetPosition(props) {
    const {positionData,loader,commonError}=props
    const {
        Symbol,
        Type,
        Net_Qty,
        Avg_Price,
        Product_Type,
        PnL,
        LTP,
        pnl_value,
        Total,
    
      } = Constants;
    
      //destructuring apply end
    
  return (
    <div>
   
    <div className="holding-comp-card">
      <div >
        <div className="holdings__title card-title d-flex justify-content-between">
          {/* <div className="figure-inlac">
            <h2 className="small-title">{Holdings}</h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          {/* </div>  */}
      
        </div>
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <div className="holdings__table scroll-table">
            {positionData && positionData.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    {/* <th scope="col">{clientId}</th> */}
                    <th scope="col">{Symbol}</th>
                    <th scope="col">{Type}</th>
                    <th scope="col">{Net_Qty}</th>
                    <th scope="col">{Avg_Price}</th>
                    <th scope="col">{Product_Type}</th>
                    <th scope="col">{LTP}</th>
                    <th scope="col">{PnL}</th>
                  </tr>
                </thead>

                <tbody>
                  {positionData &&
                    positionData.map((info, key) => {
                      const {
                        sym,
                        type,
                        netQty,
                        avgPrice,
                        ltp,
                        productType,
                        pnl,
                      } = info;
                      return (
                        <tr key={key}>
                          {/* <td>{clientId || "-"}</td> */}
                          <td>{sym || "-"}</td>
                          <td>{type|| "-"}</td>
                          <td>{netQty || 0}</td>
                          <td>{avgPrice || 0}</td>
                          <td>{productType ||"-"}</td>
                          <td>{ltp || 0}</td>
                          
                          <td>
                            <span
                              className={
                                pnl === 0
                                  ? "text-muted"
                                  : pnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                           {pnl||0}
                            </span>
                          </td>
                        
                        </tr>
                      );
                    })}
                </tbody>

                {/* <tbody className="total-holdings">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">{Total}</th>
                    
                   
                    <th
                      scope="col"
                      className={
                        totalValue?.totalPnlPer === 0
                          ? "gray-text"
                          : totalValue?.totalPnlPer > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {totalValue?.totalPnlPer ? totalValue?.totalPnlPer : 0} %
                    </th>
                  </tr>
                </tbody> */}
              </table>
            ) : (
              commonError && (
                <h4 className="no-data">{noDataFound(commonError)}</h4>
              )
            )}
          </div>
        )}
      </div>
    </div>
  

    </div>
  )
}
